import type { Course, Program } from '../types';
import { course as projectFinanceCourse } from './course';
import { upgradedAccountingCourse as accountingCourse } from './accountingUpgrade';
import { customerServiceCourse } from './customerServiceCourse';
import { salesMarketingProgram } from './salesMarketing/program';
import { buildLessonInstructorCues } from './instructorCues';

export const academyCourses:Course[]=[projectFinanceCourse,accountingCourse,customerServiceCourse,...salesMarketingProgram.courses];
academyCourses.forEach(course=>course.modules.forEach(module=>module.lessons.forEach(lesson=>{lesson.instructorCues??=buildLessonInstructorCues(course,module,lesson)})));

export const catalogCourses:Course[]=academyCourses.filter(course=>!course.programId);
export const academyPrograms:Program[]=[salesMarketingProgram];

export {projectFinanceCourse,accountingCourse,customerServiceCourse};
